import { render, staticRenderFns } from "./partenaires.vue?vue&type=template&id=5a776dbf&scoped=true&"
import script from "./partenaires.vue?vue&type=script&lang=js&"
export * from "./partenaires.vue?vue&type=script&lang=js&"
import style0 from "./partenaires.vue?vue&type=style&index=0&id=5a776dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a776dbf",
  null
  
)

export default component.exports